<template>
  <authorization
    permissionKey="attendance_exam"
    can="save"
    v-slot:default="{ authorization }"
  >
    <v-container fluid v-if="authorization">
      <v-row dense>
        <v-col class="text-h3 gray--text"> Exame </v-col>

        <v-col cols="auto" v-if="exam && exam.finished">
          <v-btn outlined color="light-blue" @click="showLockedAppraisal">
            Editar
          </v-btn>
        </v-col>

        <v-col cols="auto" v-else>
          <v-btn
            outlined
            color="light-blue"
            @click="appraisalLocker(questionLock, true, lockConfirmation)"
          >
            Laudar
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            color="gray lighten-1"
            dark
            :to="`/prontuario/${attendance.id}/exames`"
          >
            voltar
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <EsignButton :esign="exam.lastEsign" v-if="exam" />
        </v-col>
      </v-row>

      <v-row v-if="unlockingAppraisal">
        <v-col>
          <v-combobox label="Motivo da alteração"
                  v-model="editReason"
                  dense
                  :hide-details="!errors.editReason"
                  :error-messages="errors.editReason"
                  outlined
                  :items="reasons"
                  background-color="white"
                  />
        </v-col>
        <v-col>
          <v-btn
            outlined
            color="light-blue"
            @click="appraisalLocker(questionUnlock, false, lockConfirmation)"
          >
            Salvar Motivo
          </v-btn>
        </v-col>
      </v-row>

      <MedicalRequestListItem
        v-if="medicalRequest"
        :attendance="attendance"
        :medicalRequest="medicalRequest"
        :refreshMedicalRequest="refreshMedicalRequest"
        :refreshQueue="refreshQueue"
        :showExecuteBtn="false"
      />

      <ExamForm
        v-if="exam"
        :attendance="attendance"
        :exam="exam"
        :attendanceEsigned="attendanceEsigned"
        ref="examFormRef"
      />
      <FormLargeSkeletonLoader v-else :rows="7" />
    </v-container>
  </authorization>
</template>

<script>
import ExamForm from "@/components/exam/form.vue";
import MedicalRequestListItem from "@/components/medical_request/list/item/index.vue";
import FormLargeSkeletonLoader from "@/components/ui/form/large_skeleton_loader.vue";

import MEDICAL_REQUEST from "@/graphql/medical_request/medical_request.js";

export default {
  name: "Exam",
  props: {
    attendance: Object,
    attendanceEsigned: Boolean,
    examId: String,
  },
  components: {
    ExamForm,
    MedicalRequestListItem,
    FormLargeSkeletonLoader,
  },
  data() {
    return {
      medicalRequestId: "",
      editReason: "",
      unlockingAppraisal: false,
      errors: {},


      reasons:  ["Nome incorreto", "Data de nascimento incorreto","Número do prontuário errado", "Exame vinculado a paciente incorreto", "Tipo de exame incorreto selecionado", "Data do exame incorreta Lado errado (olho direito/esquerdo/tipo de imagem)", "Diagnóstico incorreto Alteração na conclusão", "Atualização de achados clínicos","Inclusão de informação adicional relevante","Correção de valores refracionais", "Ajuste de lente ou grau", "Imagem anexada incorretamente", "Falha na captura da imagem"],
      questionLock: "Você realmente deseja laudar esse exame?",
      questionUnlock: "Você realmente deseja editar esse exame laudado?",
      unlockConfirmation: "Exame editado com sucesso.",
      lockConfirmation: "Exame laudado com sucesso",
    };
  },
  mounted() {
    this.refreshList();
    this.medicalRequestId = this.$route.params.medicalRequestId;
  },
  updated() {
    this.refreshList();
  },
  apollo: {
    exam: {
      query: require("@/graphql/exam/exam.gql"),
      fetchPolicy: "no-cache",
      variables() {
        return {
          examId: this.examId,
        };
      },
      pollInterval: 10000,
    },
    medicalRequest: {
      query: MEDICAL_REQUEST,
      variables() {
        return {
          medicalRequestId: this.medicalRequestId,
        };
      },
      skip() {
        return !this.medicalRequestId;
      },
      pollInterval: 15000,
    },
  },
  methods: {
    showLockedAppraisal() {
      this.unlockingAppraisal = true;
    },
    refreshList() {
      this.$apollo.queries.exam.refetch();
    },
    refreshQueue() {
      this.$apollo.queries.medicalRequestsQueue.refetch();
    },
    refreshMedicalRequest() {
      this.$apollo.queries.medicalRequest.refetch();
    },
    async saveMedicalReportOnExamForm() {
      await this.$refs.examFormRef.saveManager.triggerManualSave();
    },
    async appraisalLocker(question, finished, confirmation) {
      await this.saveMedicalReportOnExamForm();
      if (await !this.validate()) return;
      if (confirm(question)) {
        await this.apolloMutate({
          mutation: require("@/graphql/exam/lock_appraisal.gql"),
          variables: {
            examId: this.exam.id,
            editReason: this.editReason,
            finished: finished,
          },
        });
        await this.refreshList();
        await this.appraisalNotification(confirmation);

        this.editReason = "";
        this.unlockingAppraisal = false;
      }
    },
    async appraisalNotification(message) {
      await this.$store.dispatch("createNotification", {
        message: message,
        type: "success",
      });
    },
    async validate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      let editReason = this.editReason;
      if (this.lodash.isEmpty(editReason?.trim())) {
        this.errors.editReason = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
